import React from 'react';
import 'components/card/service/serviceCard.style.scss';
import Helper from '../../../core/helper/helper';
import CardItemInformation from '../equipment/CardItemInformation';
import CardCorner from './cardCorner';
import { GENERAL } from '../../../assets/images/images';
import CardServiceState from './CardServiceState';
import FeedbackBoxCard from '../../feedback/feedbackBoxCard';
import Button from '../../button/button.jsx';
import Modal, { Information } from '../../modal/modal';
import Labels from '../../../variables/labels';
import ServiceNotificationWidgets from './serviceNotificationWidgets';
import Cookies from 'universal-cookie';
import PhoneCallButton from '../../button/PhoneCallButton.jsx';
import LocalData from "../../../core/localData";
// import { toast } from 'react-toastify';

class ServiceDetailsCard extends React.Component {
  constructor(props) {
    super(props);
    this.cookies = new Cookies();
    this.refModal = React.createRef();
    const is_product_services = LocalData.configData.worksheet_operational === "false";
    const {
      isLiteVersion,
      data: { id, item, phase, state, dateStart, old_date, dateEnd, old_time, time, time_end,
        feedback, schedule, token, token_cal, checkoutInfo, showUnreadCheck, showPaymentAction,
        showUnreadMessage, hasMessage, allowApprove, showInternalNotes, isAppointment, is_cancelled, is_history, missedAppointment, establishment,
        fromMessageNotification, fromPayNotif, fromApproveNotif, is_confirmed, full_day
      }
    } = this.props;
    this.refInput = React.createRef();
    this.state = {
      id: id,
      item: Helper.initialItemState(item, isLiteVersion, isAppointment),
      phase: phase,
      state: {
        bars: state?.bars,
        name: state?.bars === 2.5 && !allowApprove 
              ? 'Aguarda aprovação' 
              : state?.bars === 1 && is_product_services
                ? 'Pedido a decorrer'
                : state?.name,
      },
      dateStartState: Helper.printDate(dateStart),
      dateEndState: Helper.printDate(dateEnd),
      dateStart,
      old_date,
      dateEnd,
      old_time,
      time,
      time_end,
      feedback: feedback || { classification: undefined, observation: undefined },
      feedbackBD: feedback,
      schedule: schedule,
      stateWarning: state.bars === 5 && !feedback,
      stateAction: allowApprove || showPaymentAction, //state.bars === 2.5, // aguarda aprovação
      stateCheck: state.bars === 4, // aguarda cliente
      showUnreadCheck,
      showPaymentAction,
      stateMessage: !!hasMessage, // tem mensagem de prestador
      showUnreadMessage,
      checkoutInfo,
      token,
      token_cal: token_cal,
      allowApprove: allowApprove,
      showInternalNotes,
      isAppointment: isAppointment,
      is_cancelled: is_cancelled,
      is_confirmed: is_confirmed,
      is_history,
      missedAppointment,
      establishment,
      fromMessageNotification, fromPayNotif, fromApproveNotif,
      full_day,
      isSubmitting: false
    }

  }

  componentDidMount(){
    const is_cancelled = this.state.is_cancelled;
    let searchParams = new URLSearchParams(this.props.location?.search);
    if (searchParams.has('feedback')) {
      searchParams.delete('feedback');

      if ((this.props.data?.state.bars===5 ||
          (this.props.data?.isAppointment && this.props.data?.is_history && LocalData.configData.is_scheduler_solo && !is_cancelled)) 
        && !this.props.data.feedback 
        && !this.props.isLiteVersion) {
        try{this.toggleShowFeedback();}
        catch{
          console.error('');
        }
      }
    }
  }

  componentDidUpdate(prevProps) {
    const prevData = prevProps.data || {};
    const nextData = this.props.data || {};
    const hasRelevantPropChanges =
      prevData.state !== nextData.state ||
      prevData.dateStart !== nextData.dateStart ||
      prevData.old_date !== nextData.old_date ||
      prevData.dateEnd !== nextData.dateEnd ||
      prevData.old_time !== nextData.old_time ||
      prevData.time !== nextData.time ||
      prevData.time_end !== nextData.time_end ||
      prevData.feedback !== nextData.feedback ||
      prevData.schedule !== nextData.schedule ||
      prevData.checkoutInfo !== nextData.checkoutInfo ||
      prevData.showUnreadCheck !== nextData.showUnreadCheck ||
      prevData.token_cal !== nextData.token_cal ||
      prevData.showUnreadMessage !== nextData.showUnreadMessage ||
      prevData.hasMessage !== nextData.hasMessage ||
      prevData.allowApprove !== nextData.allowApprove ||
      prevData.showInternalNotes !== nextData.showInternalNotes ||
      prevData.showPaymentAction !== nextData.showPaymentAction ||
      prevData.is_history !== nextData.is_history ||
      prevData.is_cancelled !== nextData.is_cancelled ||
      prevData.missedAppointment !== nextData.missedAppointment ||
      prevData.establishment !== nextData.establishment ||
      prevData.is_confirmed !== nextData.is_confirmed ||
      prevData.full_day !== nextData.full_day ||
      prevData.id !== nextData.id;

    if (!hasRelevantPropChanges) {
      return;
    }

    const {
      data: { state, dateStart, old_date, dateEnd, old_time, time, time_end, feedback, schedule, checkoutInfo, showUnreadCheck, token_cal,
        showUnreadMessage, hasMessage, allowApprove, showInternalNotes, showPaymentAction, is_history, is_cancelled, missedAppointment, establishment, is_confirmed, full_day, id }
    } = this.props;
    const is_product_services = LocalData.configData.worksheet_operational === "false";
    const shouldSyncFeedback = prevData.feedback !== feedback || prevData.id !== id;

    this.setState(prevState => ({
      state: {
        bars: state?.bars,
        name: state?.bars === 2.5 && !allowApprove 
              ? 'Aguarda aprovação' 
              : state?.bars === 1 && is_product_services
                ? 'Pedido a decorrer'
                : state?.name,
      },
      dateStartState: Helper.printDate(dateStart),
      dateEndState: Helper.printDate(dateEnd),
      dateStart,
      old_date,
      dateEnd,
      old_time,
      time,
      time_end,
      feedback: shouldSyncFeedback ? (feedback || { classification: undefined, observation: undefined }) : prevState.feedback,
      feedbackBD: shouldSyncFeedback ? feedback : prevState.feedbackBD,
      schedule: schedule,
      stateWarning: state.bars === 5 && !feedback,
      stateAction: allowApprove || showPaymentAction, //state.bars === 2.5, // aguarda aprovação
      stateCheck: state.bars === 4, // aguarda cliente
      showUnreadCheck,
      showPaymentAction,
      stateMessage: !!hasMessage, // tem mensagem de prestador
      showUnreadMessage,
      checkoutInfo,
      allowApprove: allowApprove,
      showInternalNotes,
      token_cal: token_cal,
      is_cancelled: is_cancelled,
      is_confirmed: is_confirmed,
      is_history,
      missedAppointment,
      establishment,
      full_day
    }));
  }

  handlePressEvent = () => {
    this.props.onClick(this.state.id);
  }

  validateSubmition = () => {
    const { feedback, isSubmitting } = this.state;
    if (isSubmitting) {
      return;
    }
    this.setState({ isSubmitting: true });
    try {
      const result = this.props.callback && this.props.callback(feedback);
      const finish = () => this.setState({ isSubmitting: false });
      // If callback returns a Promise, resolve it and toggle only on success
      if (result && typeof result.then === 'function') {
        result
          .then((res) => {
            if (res === true || (res && res.success === true)) {
              this.toggleShowFeedback();
            }
          })
          .catch(() => {
            // do not toggle on error
          })
          .finally(finish);
        return;
      }
      finish();
      // Synchronous result: toggle only if explicitly successful
      if (result === true || (result && result.success === true)) {
        this.toggleShowFeedback();
      }
    } catch (_) {
      // swallow and do not toggle
      this.setState({ isSubmitting: false });
    }
  }

  renderCardInformation = () => {
    const { id } = this.props;
    const { showFeedback, feedback } = this.state;
    if (showFeedback) {
      return(
        <FeedbackBoxCard data={{ valueRating: feedback?.classification, observation: feedback?.observation, id }} type="medium"
          callback={(f, isSub = false) => this.updateFeedbackState(f, isSub)}/>
      );
    }
    return (
      <React.Fragment>
        {this.renderItemInformation()}
        {this.renderCardServiceState()}
      </React.Fragment>
    );
  }

  updateFeedbackState = (feedback, isSubmition) => {
    if (feedback) {this.setState({feedback});}
    if (!isSubmition) {
      return;
    }

    this.validateSubmition();
  }

  renderItemInformation = () => {
    const { item: { title, subtitle } } = this.state;
    return <CardItemInformation data={{ title, subtitle }} styleClass="mt-3 mt-md-0 text-start details"/>
  }

  renderCardServiceState = () => {
    const { data: { schedule }} = this.props;
    const { state, dateStart, old_date, dateEnd, old_time, time, time_end, dateStartState, dateEndState, checkoutInfo, isAppointment, is_cancelled, is_history, missedAppointment, is_confirmed, full_day } = this.state;
    return (
      <CardServiceState
        data={{ dateStart, old_date, schedule, dateEnd, old_time, time, time_end, state, dateStartState, dateEndState, checkoutInfo, isAppointment, is_cancelled, is_history, missedAppointment, is_confirmed, full_day}}
        isSmall={false} styleClass='mt-2 mt-md-4 w-auto details'
      />
    );
  }

  renderCardCorner = (bars, feedback) => {
    const { isAppointment, is_history, is_cancelled, missedAppointment } = this.state;
    const is_scheduler_solo = LocalData.configData.is_scheduler_solo;

    if (this.state.showFeedback || (isAppointment && is_cancelled) || missedAppointment) {
      return;
    }
    return <CardCorner data={{bars, feedback, isAppointment, is_history, is_scheduler_solo}} styleClass="details"
      onReviewClick={this.toggleShowFeedback}/>
  }

  renderLocationContainer = () => {
    const { establishment, feedback, showFeedback, isAppointment, is_history, is_cancelled, state: { bars }, missedAppointment } = this.state;
    const buttonLabel = feedback?.classification ? 'Ver Pontuação' : 'Enviar Feedback';
    const address = LocalData.configData?.companyDetails?.address ? LocalData.configData?.companyDetails?.address : '';
    const externalMapsURL = Helper.isIOS() || Helper.isIOSWebview()
        ? `http://maps.apple.com/?q=${encodeURIComponent(establishment?.name + ", " + address)}`
        : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(establishment?.name + ", " + address)}`;
    const is_scheduler_solo = LocalData.configData.is_scheduler_solo;

    if (showFeedback) {
      return;
    }

    if ((bars === 5) || (isAppointment && is_history && is_scheduler_solo && !is_cancelled && !missedAppointment)) {
      return (
        <div className="d-flex justify-content-between">
          <div className="card-service-location" style={{ minWidth: 0 }} title={'Localização'}>
            <img src={GENERAL.location} alt="" />
            <div className="mx-1 text-truncate">
              {Helper.isDemo(establishment?.name) ? "Empresa Demo" : 
                <a className="text-color-black" style={{ textDecoration: 'underline'}} target="_blank" rel="noopener noreferrer" href={externalMapsURL}>
                  <span className={``}>{establishment?.name}</span>
                </a>
              }
            </div>
            <div className="distance ms-1 me-2 text-color-grey-blue text-font-size-regular text-nowrap">
              {LocalData.configData?.companyDetails?.distance ? 
                Helper.formatDistance(LocalData.configData?.companyDetails?.distance) :
                establishment?.distance ? 
                  Helper.formatDistance(establishment?.distance) : 
                  "" }
            </div>
          </div>

          <div className="d-flex align-items-center">
            <div className="cta-show-feedback me-2" role={'button'}
              onClick={this.toggleShowFeedback}>
              <img src={GENERAL.starFillOrange} alt="" />
              <span className='ms-1 cta-text text-nowrap'>{buttonLabel}</span>
            </div>
            <PhoneCallButton isServiceDetails={true} />
          </div>
        </div>
      );
    }
    return (
      <div className="d-flex w-100">
        <div className="d-sm-none flex-grow-1" style={{ maxWidth: "45px"}}></div>
        <div className="card-service-location d-flex justify-content-center justify-content-sm-start flex-grow-1" style={{ minWidth: 0 }}>
          <img src={GENERAL.location} alt="Location" />
          <div className="mx-1 text-truncate" style={{ minWidth: 0 }}>
            {Helper.isDemo(establishment?.name) ? "Empresa Demo" :
              <a className="text-color-black" style={{ textDecoration: 'underline'}} target="_blank" rel="noopener noreferrer" href={externalMapsURL}>
                <span className={``}>{establishment?.name}</span>
              </a>
            }
          </div>
          <div className="distance ms-1 me-2 text-color-grey-blue text-font-size-regular text-nowrap">
            {LocalData.configData?.companyDetails?.distance ?
              Helper.formatDistance(LocalData.configData?.companyDetails?.distance) :
              establishment?.distance ?
                Helper.formatDistance(establishment?.distance) :
                ""}
          </div>
        </div>
        <div className="flex-shrink-0">
          <PhoneCallButton isServiceDetails={true} />
        </div>
      </div>
    );
  }

  onClickShare = () => {
    const { token, token_cal, isAppointment } = this.state;
    const shareLink = isAppointment? `https://${window.location.host}${process.env.PUBLIC_URL}/services-lite?token_cal=${token_cal}&s=C&t=0` : `https://${window.location.host}${process.env.PUBLIC_URL}/services-lite?token=${token}&s=C&t=0`;
    const shareData = {
      title: Labels.shareService.title,
      text: Labels.shareService.text,
      url: shareLink
    };
    this.openShareNavigator(shareData);
  };

  openShareNavigator(shareData) {
    const title = shareData.title;
    const text = shareData.text;
    const url = shareData.url;
    if (navigator.share) {
      navigator.share(shareData).then(() => { })
        .catch(console.error);
    } else if (Helper.isAndroidWebview()) {
      try {
        window.Android.enableShareMenu(title, text, url);
      } catch (error) {
        console.error(error);
      }
    } else if (Helper.isIOSWebview() && !window.MSStream) {
      try {
        window.webkit.messageHandlers.enableShareMenu.postMessage({ title, text, url });
      } catch (error) {
        console.error(error);
      }
    }
    else {
      this.renderModal(
        <Information
          title={Labels.shareService.copyAsk}
          confirmText={Labels.shareService.confirm}
          onClick={() => {
            this.refModal.current.closeModal();
            return this.copyLink(shareData);
          }}
        />
      );
    }
  }

  copyLink = (shareData) => {
    navigator.clipboard.writeText(shareData?.url);
    setTimeout(() => {
      this.renderInfoModal(Labels.shareService.copySuccess);
      // toast.success(Labels.shareService.copySuccess, Helper.toastOptions);
      // toast.warning(
      //   <div className="toast-title">
      //     Urgent: <span style={{ fontWeight: "normal" }}>Check your settings!</span>
      //   </div>,
      //   Helper.toastOptions
      // );
    }, 200);
  }

  renderItemImage = (item) => {
    const renderShareButton = () => {
      return (
        <div className="share-button-container me-2">
          <div role={'button'} className="share-icon d-flex" onClick={this.onClickShare}>
            <img src={GENERAL.share} alt="share-icon" />
          </div>
        </div>
      );
    };
    return (
      <div className="card-service-image-container details">
        <img
          src={item.image}
          alt="service_image"
          className={Helper.isLiteVersion() ? "pixelized" : ""}
          onError={(e) => (e.target.src = Helper.defaultImage())}
        />
        {renderShareButton()}
      </div>
    );
  }

  toggleShowFeedback = () => {
    this.setState(prevState => ({
      showFeedback: !prevState.showFeedback
    }));
  }

  resetFeedback = () => {
    this.setState(state => ({
      feedback: state.feedbackBD
    }));
    this.toggleShowFeedback();
  }

  renderCTAFeedbackContainer = () => {
    const { showFeedback, isSubmitting } = this.state;

    if (!showFeedback) {
      return;
    }

    return (
      <div className="feedback-cta-container d-flex justify-content-between align-items-center mt-2">
        <div className="d-inline-flex align-items-center link-container me-3" role="button" onClick={this.resetFeedback}>
          <img src={GENERAL.arrowLeft} alt="icon-link" className="me-1" />
          <span>voltar atrás</span>
        </div>
        <Button className='cta-button-primary d-medium ms-1 px-5' type='button'
          value={isSubmitting ? 'A enviar...' : 'Submeter Feedback'}
          disabled={isSubmitting}
          onClick={() => {
            this.validateSubmition();
          }} />
      </div>
    );
  }

  renderCTAContainer = () => {
    const {showFeedback } = this.state;
    const styleClass = !showFeedback ? 'd-none' : 'd-flex';
    return (
      <div className={`card-cta-container ${styleClass} mt-3 mb-0 mb-sm-3 justify-content-between d-sm-flex`}>
        <div className='d-none d-sm-block w-100'>
          {this.renderLocationContainer()}
        </div>
        {this.renderCTAFeedbackContainer()}
      </div>
    );
  }

  renderInfoModal = (title, message) => {
    this.renderModal(
      <Information
        title={title}
        text={message}
        onClick={() => this.refModal.current.closeModal()} />
    );
  }

  renderModal = (view) => {
    this.refModal.current.renderView(view);
    this.refModal.current.openModal();
  }

  render() {
    const { state, item, feedback, stateAction, stateCheck, stateMessage, showUnreadCheck,
      showUnreadMessage, allowApprove, showInternalNotes, showPaymentAction, 
      fromMessageNotification, fromConfirmNotif, fromPayNotif, fromApproveNotif, fromFeedbackNotif 
    } = this.state;
    return (
      <React.Fragment>
        <div className={`card-service-main-container p-3 w-100 m-0 h-auto mw-100`}>
          <ServiceNotificationWidgets
            data={{stateAction, stateCheck, stateMessage, source: 'details', showUnreadCheck, showUnreadMessage, allowApprove, showInternalNotes, showPaymentAction, 
                  fromMessageNotification, fromConfirmNotif, fromPayNotif, fromApproveNotif, fromFeedbackNotif}}
            onRead={this.props.onReadMessage}
            onReadCheck={this.props.onReadCheck}/>
          {this.renderCardCorner(state.bars, feedback)}
          <div className='row'>
            <div className="col-12 col-sm-6 col-lg-12 col-xl-6">
              {this.renderItemImage(item)}
            </div>
            <div className="col-12 col-sm-6 col-lg-12 col-xl-6 details-page">
              {this.renderCardInformation()}
            </div>
          </div>
          {this.renderCTAContainer()}
        </div>
        <div className="mt-3 d-sm-none w-100">
          {this.renderLocationContainer()}
        </div>
        <Modal ref={this.refModal} />
      </React.Fragment>
    );
  }
}


export default ServiceDetailsCard;